import { render, staticRenderFns } from "./SipSettings.vue?vue&type=template&id=af1c1aa4&scoped=true"
import script from "./SipSettings.vue?vue&type=script&lang=js"
export * from "./SipSettings.vue?vue&type=script&lang=js"
import style0 from "./SipSettings.vue?vue&type=style&index=0&id=af1c1aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1c1aa4",
  null
  
)

export default component.exports